/**
 * product-upsell.js — Last updated: July 29, 2025
 *
 * This script dynamically updates the visible price display
 * in product upsell carousels when a user selects a different variant.
 *
 * It synchronizes the variant ID for form submission and replaces
 * the contents of `.product-upsell-price` with the matching block from
 * `.product-upsell-price-variants`.
 *
 * Related Files:
 * - snippets/card-product.liquid (renders variant-specific price blocks)
 * - snippets/product-upsell.liquid (includes carousel and price containers)
 */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card-wrapper').forEach((card) => {
    const form = card.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const select = form.querySelector('select[name="select-variant"]');
    const idInput = form.querySelector('input[name="id"]');
    const priceDisplay = card.querySelector('.product-upsell-price');
    const priceVariantsContainer = card.querySelector('.product-upsell-price-variants');

    if (!select || !idInput || !priceDisplay || !priceVariantsContainer) return;

    function updatePriceDisplay(variantId) {
      const newPriceBlock = priceVariantsContainer.querySelector(`[data-variant-id="${variantId}"]`);
      if (!newPriceBlock) return;

      priceDisplay.innerHTML = newPriceBlock.innerHTML;

      const hasSale = priceDisplay.querySelector('.price__sale');
      priceDisplay.classList.toggle('price--on-sale', !!hasSale);
    }

    select.addEventListener('change', function () {
      const selectedVariantId = this.value;
      idInput.value = selectedVariantId;
      updatePriceDisplay(selectedVariantId);
    });

    // Set initial price on page load
    const initialVariantId = select.value;
    idInput.value = initialVariantId;
    updatePriceDisplay(initialVariantId);
  });
});
